{
  "admission": "入院",
  "transfer": "轉科",
  "visit": "就醫",
  "type": "就醫類型",
  "status": "狀態",
  "location": "科室位置",
  "attendingPhysician": "主治醫師",
  "admitDate": "入院日期",
  "dischargeDate": "出院日期",
  "chiefComplaint": "主訴",
  "diagnosis": "診斷",
  "class": {
    "label": "類別",
    "values": {
      "emergency": "急診",
      "inpatient": "住院",
      "outpatient": "門診",
      "observation": "觀察",
      "ambulatory": "日間醫療",
      "homeHealth": "居家醫療",
      "virtual": "遠距醫療"
    }
  },
  "statusValues": {
    "label": "狀態",
    "values": {
      "pending": "待處理",
      "arrived": "已到達",
      "active": "進行中",
      "completed": "已完成",
      "cancelled": "已取消"
    }
  },
  "admissionSource": {
    "label": "入院來源",
    "none": "—",
    "values": {
      "emergency": "急診部",
      "clinicReferral": "門診轉介",
      "physicianReferral": "醫師轉介",
      "transfer": "由其他院所轉入",
      "self": "自行就醫 / 步入",
      "courtLaw": "司法 / 執法機關"
    }
  },
  "admissionType": {
    "label": "入院類型",
    "none": "—",
    "values": {
      "elective": "預約",
      "emergency": "急診",
      "urgent": "緊急",
      "newborn": "新生兒",
      "trauma": "創傷"
    }
  },
  "acuity": {
    "label": "病情等級",
    "none": "—",
    "values": {
      "1": "1 — 復甦",
      "2": "2 — 危急",
      "3": "3 — 緊急",
      "4": "4 — 次緊急",
      "5": "5 — 非緊急"
    },
    "shortValues": {
      "1": "復甦",
      "2": "危急",
      "3": "緊急",
      "4": "次緊急",
      "5": "非緊急"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "新增就醫",
    "subtitle": "為此病人開始新的就醫 / 入院。",
    "sections": {
      "visit": "就醫資料",
      "reasonForVisit": "就醫原因",
      "admission": "入院資料"
    },
    "fields": {
      "facility": "院區",
      "encounterClass": "就醫類別",
      "encounterType": "就醫類型",
      "department": "科別",
      "attendingProvider": "主治醫師",
      "acuity": "病情等級",
      "visitReason": "就醫原因",
      "chiefComplaint": "主訴",
      "admissionSource": "入院來源",
      "admissionType": "入院類型"
    },
    "placeholders": {
      "selectFacility": "選擇院區",
      "none": "—",
      "encounterType": "例如:年度健檢、急診就醫",
      "visitReason": "簡短標籤,例如:回診、年度健檢",
      "chiefComplaint": "病人以自己的話陳述的就醫原因"
    },
    "providerFallback": "醫師 #{{id}}",
    "submit": "建立就醫",
    "validation": {
      "facilityRequired": "請選擇院區",
      "encounterClassRequired": "請選擇就醫類別"
    },
    "createdSuccess": "就醫已建立",
    "createError": "建立就醫失敗"
  },
  "detail": {
    "loading": "正在載入就醫資料...",
    "notFound": "找不到此就醫",
    "loadError": "載入就診失敗",
    "retry": "重試",
    "returnToDashboard": "返回控制台",
    "header": {
      "title": "就醫 {{number}}",
      "facilityLabel": "院區 #{{id}}",
      "departmentLabel": "科別 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "admittedLabel": "入院時間:{{datetime}}"
    },
    "actions": {
      "transfer": "轉科",
      "discharge": "出院"
    },
    "tabs": {
      "overview": "總覽",
      "orders": "醫囑",
      "results": "檢驗結果",
      "medications": "用藥",
      "notes": "病歷",
      "billing": "費用"
    },
    "overview": {
      "chiefComplaint": "主訴",
      "visitReason": "就醫原因",
      "attendingProvider": "主治醫師",
      "acuityLevel": "病情等級",
      "providerFallback": "醫師 #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "事件時間軸",
      "empty": "尚無事件紀錄",
      "admittedTitle": "入院",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "無主訴",
      "orderTitle": "醫囑:{{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "結果:{{type}}"
    },
    "orders": {
      "title": "醫囑",
      "newOrder": "+ 新增醫囑",
      "empty": "此就醫尚無醫囑",
      "metaLine": "{{number}} | {{type}} | 優先順序:{{priority}}"
    },
    "results": {
      "title": "檢驗結果",
      "empty": "此就醫尚無檢驗結果",
      "criticalBadge": "危急",
      "viewLink": "檢視",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "用藥",
      "newMedication": "+ 新增用藥",
      "empty": "此就醫尚無用藥",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN:{{indication}}"
    },
    "notes": {
      "comingSoon": "臨床病歷模組即將推出",
      "goToClinicalNotes": "前往臨床病歷"
    },
    "billing": {
      "comingSoon": "費用模組即將推出"
    }
  },
  "census": {
    "title": "病床看板 / 在院名單",
    "subtitle": "即時病床佔用與病人在院狀況",
    "refresh": "重新整理",
    "facilityName": "新加坡中央醫院",
    "capacitySummary": "已用 {{occupied}} / 共 {{total}} 張病床",
    "occupancyLabel": "佔用率 {{percent}}%",
    "stats": {
      "totalCapacity": "床位總數",
      "occupied": "已佔用",
      "available": "可用",
      "pendingDischarge": "待出院"
    },
    "unitFilter": {
      "all": "全部病房",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "內外科",
      "obs": "觀察室",
      "peds": "兒科",
      "maternity": "產科"
    },
    "roleView": {
      "nurse": "護理師檢視",
      "physician": "醫師檢視",
      "bedManager": "床位管理檢視"
    },
    "viewMode": {
      "grid": "格狀檢視",
      "table": "表格檢視"
    },
    "loading": "正在載入在院資料...",
    "columns": {
      "patient": "病人",
      "mrn": "MRN",
      "admitDate": "入院日期",
      "status": "狀態",
      "acuity": "病情等級",
      "isolation": "隔離",
      "fallRisk": "跌倒風險",
      "codeStatus": "急救等級",
      "chiefComplaint": "主訴",
      "attending": "主治",
      "los": "LOS",
      "locationBed": "位置 / 病床",
      "transferStatus": "轉科狀態",
      "expectedDischarge": "預計出院",
      "actions": "操作"
    },
    "values": {
      "unknownPatient": "未知",
      "none": "無",
      "notAvailable": "N/A",
      "pending": "待處理",
      "empty": "--",
      "providerFallback": "醫師 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "losDays": "{{days}}日"
    },
    "codeStatusTooltip": "急救等級可於病人病歷查閱",
    "actionsMenu": {
      "label": "操作",
      "viewChart": "檢視病歷",
      "transfer": "轉科",
      "assignAttending": "分配主治醫師",
      "discharge": "出院"
    },
    "empty": "尚無在院就醫",
    "department": {
      "filteredTo": "僅顯示 {{name}}",
      "idLabel": "科別 {{id}}",
      "showAll": "顯示所有科別"
    },
    "facility": {
      "label": "機構",
      "allFacilities": "所有機構",
      "idLabel": "機構 {{id}}"
    }
  },
  "discharge": {
    "label": "出院",
    "title": "出院流程",
    "encounterLabel": "就醫 {{number}}",
    "printButton": "列印出院記錄",
    "loading": "正在載入就醫資料...",
    "notFound": "找不到該就醫",
    "returnToDashboard": "返回儀表板",
    "notActive": "該就醫並非進行中(目前狀態:{{status}})",
    "backToEncounter": "返回就醫頁",
    "progress": {
      "requiredMissingTooltip": "必填欄位未填寫",
      "tasksRemainingTooltip": "仍有未完成的項目"
    },
    "steps": {
      "summary": "出院摘要",
      "medications": "用藥",
      "followup": "回診",
      "instructions": "出院指導",
      "nursing": "護理任務",
      "signoff": "主治醫師簽核",
      "review": "覆核與確認"
    },
    "summary": {
      "title": "出院摘要",
      "diagnosisLabel": "出院診斷 *",
      "diagnosisPlaceholder": "請輸入出院診斷...",
      "diagnosisCodeLabel": "出院診斷代碼(ICD-10)",
      "diagnosisCodePlaceholder": "搜尋 ICD-10 代碼...",
      "proceduresLabel": "已執行之處置",
      "proceduresPlaceholder": "列出本次就醫期間執行的處置...",
      "conditionLabel": "出院時情況 *"
    },
    "condition": {
      "values": {
        "stable": "穩定",
        "improved": "改善",
        "unchanged": "無變化",
        "worsened": "惡化",
        "critical": "危急"
      }
    },
    "medications": {
      "title": "出院帶藥",
      "instructions": "請逐項審視藥物,決定繼續使用、停用或調整。",
      "actions": {
        "continue": "繼續",
        "stop": "停用",
        "modify": "調整"
      },
      "modifiedPlaceholder": "請輸入調整後的用藥說明...",
      "empty": "本次就醫無在用藥物"
    },
    "medAction": {
      "values": {
        "continue": "繼續",
        "stop": "停用",
        "modify": "調整"
      }
    },
    "followup": {
      "title": "回診安排",
      "providerLabel": "回診醫師",
      "providerPlaceholder": "醫師姓名或專科...",
      "dateLabel": "回診日期",
      "notesLabel": "其他備註",
      "notesPlaceholder": "其他回診備註..."
    },
    "instructions": {
      "title": "病人出院指導",
      "generalLabel": "一般指導",
      "generalPlaceholder": "提供給病人的一般出院指導...",
      "dietaryLabel": "飲食指導",
      "dietaryPlaceholder": "飲食限制或建議...",
      "activityLabel": "活動限制",
      "activityPlaceholder": "身體活動限制...",
      "warningSignsLabel": "需警覺的症狀",
      "warningSignsPlaceholder": "出現這些症狀時病人應及時回診或就醫..."
    },
    "nursing": {
      "title": "護理任務",
      "instructions": "出院前請完成以下清單。此處項目僅作紀錄,不會呼叫 API。",
      "tasks": {
        "removeIv": "移除 IV 管路",
        "discontinueMonitoring": "停止監視設備",
        "patientEducation": "完成病人衛教",
        "medsReviewed": "已與病人核對出院帶藥",
        "belongingsReturned": "歸還個人物品",
        "transportArranged": "已安排離院交通"
      }
    },
    "signoff": {
      "title": "主治醫師簽核",
      "instructions": "請覆核下列出院摘要後完成主治醫師簽核。",
      "diagnosisHeading": "出院診斷",
      "notProvided": "未填寫",
      "medicationsHeading": "出院帶藥",
      "noMedications": "無須核對藥物",
      "signedCompleted": "主治醫師簽核完成。",
      "signAsAttending": "以主治醫師身份簽核",
      "requiresAttendingSignoff": "需要主治醫師簽核"
    },
    "review": {
      "title": "覆核並確認出院",
      "summaryHeading": "出院摘要",
      "fields": {
        "diagnosis": "診斷:",
        "procedures": "處置:",
        "condition": "情況:",
        "provider": "醫師:",
        "date": "日期:",
        "notes": "備註:",
        "general": "一般:",
        "diet": "飲食:",
        "activity": "活動:",
        "warningSigns": "警覺症狀:"
      },
      "medicationsHeading": "藥物核對",
      "noMedications": "無須核對藥物",
      "followupHeading": "回診",
      "instructionsHeading": "出院指導",
      "noInstructions": "未填寫出院指導",
      "pendingOrdersWarning": "可能尚有未完成醫囑或未簽核病歷,完成出院前請確認。",
      "diagnosisRequired": "完成出院前必須填寫出院診斷。",
      "empty": "--"
    },
    "nav": {
      "previous": "上一步",
      "next": "下一步",
      "complete": "完成出院"
    },
    "toast": {
      "success": "病人已成功出院",
      "error": "完成出院失敗"
    }
  },
  "components": {
    "transferDialog": {
      "title": "轉移就診",
      "description": "將病人轉移至本機構內的其他位置。",
      "targetLocationLabel": "目標位置",
      "loadingLocations": "正在載入位置…",
      "selectLocation": "請選擇位置",
      "emptyState": "本機構內沒有其他啟用中的位置。",
      "reasonLabel": "原因",
      "reasonPlaceholder": "例如：需隔離、加護降階、需更高照護等級床位",
      "actions": {
        "transfer": "轉移"
      },
      "toasts": {
        "success": "就診已轉移",
        "error": "轉移就診失敗"
      }
    },
    "assignAttendingDialog": {
      "title": "分配主治醫師",
      "description": "設定負責此次就診的主治醫師。",
      "providerLabel": "主治醫師",
      "loadingProviders": "正在載入醫師…",
      "selectProvider": "選擇醫師",
      "emptyState": "此機構目前沒有在職醫師。",
      "actions": {
        "assign": "分配"
      },
      "toasts": {
        "success": "主治醫師已分配",
        "error": "無法分配主治醫師"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "可用",
        "occupied": "佔用",
        "reserved": "預留",
        "cleaning": "清潔中",
        "closed": "關閉",
        "isolated": "隔離",
        "contaminated": "已污染"
      },
      "acuityLegendLabel": "ESI 急診分級：",
      "empty": "未設定病房",
      "summary": {
        "available_one": "{{count}} 可用",
        "available_other": "{{count}} 可用",
        "occupied_one": "{{count}} 佔用",
        "occupied_other": "{{count}} 佔用",
        "reserved_one": "{{count}} 預留",
        "reserved_other": "{{count}} 預留",
        "cleaning_one": "{{count}} 清潔中",
        "cleaning_other": "{{count}} 清潔中",
        "closed_one": "{{count}} 關閉",
        "closed_other": "{{count}} 關閉",
        "isolated_one": "{{count}} 隔離",
        "isolated_other": "{{count}} 隔離",
        "contaminated_one": "{{count}} 已污染",
        "contaminated_other": "{{count}} 已污染"
      }
    },
    "protocolPanel": {
      "title": "方案登錄",
      "enroll": "登錄",
      "availableProtocols": "可用方案",
      "loadingProtocols": "正在載入方案...",
      "noProtocols": "暫無可用方案",
      "stepBadge": "步驟 {{current}}/{{total}}",
      "loadingEnrollments": "正在載入登錄...",
      "noEnrollments": "暫無有效的方案登錄",
      "completeStep": "完成步驟",
      "toasts": {
        "enrollSuccess": "已登錄方案",
        "enrollError": "方案登錄失敗",
        "advanceSuccess": "步驟已完成",
        "advanceError": "步驟推進失敗"
      }
    }
  }
}
